import { useEffect, useRef } from 'react';

const useLottieAnimation = enable => {
    const lottieRef = useRef(null);

    useEffect(() => {
        if (
            enable &&
            lottieRef.current &&
            lottieRef.current.anim &&
            !lottieRef.current.anim.isPaused
        ) {
            lottieRef.current.anim.stop();
        }
    });

    const play = () => enable && lottieRef.current.anim.play();
    const stop = () => enable && lottieRef.current.anim.stop();
    const pause = () => enable && lottieRef.current.anim.pause();

    return {
        lottieRef,
        play,
        stop,
        pause,
    };
};

export default useLottieAnimation;
